import { useEffect, useState, useRef } from "react";

/**
 * @description Reads clipboard data and returns true if clipboard is empty
 */
const useClipboard = ({ updateFrequency = 1000 } = {}) => {
  const [isClipboardEmpty, setClipboardContent] = useState(false);
  let readClipboardIntervalId = useRef();

  useEffect(() => {
    let mounted = true;
    readClipboard();

    return () => {
      mounted = false;
      clearInterval(readClipboardIntervalId.current);
    };
  }, []);

  const readClipboard = async () => {
    try {
      const permission = await navigator.permissions.query({
        name: "clipboard-read",
      });
      if (permission.state === "denied") {
        throw new Error("Permission denied.");
      }
      if (navigator.permissions && navigator.clipboard) {
        navigator.permissions
          .query({ name: "clipboard-read" })
          .then(({ state }) => {
            if (["granted", "prompt"].includes(state)) {
              readClipboardIntervalId.current = setInterval(() => {
                navigator.clipboard.read().then(
                  () => {
                    setClipboardContent(false);
                  },
                  (issue) => {
                    if (issue?.toString()?.includes("No valid data")) {
                      setClipboardContent(true);
                    }
                  }
                );
              }, updateFrequency);
            } else {
              console.error(
                "Clipboard Read permission has been blocked by the user."
              );
            }
          });
      }
    } catch (e) {
      console.error(
        "Error reading clipboard"
      );
    }
  };
  return [isClipboardEmpty];
};

export default useClipboard;
